import { useIntl } from 'react-intl'

import Typography from '../../../../../../components/Typography/Typography'
import Icon from '../../../../../../components/Icon/Icon'

import './MobileLegend.scss'

const MobileLegend = ({ type }) => {
    const intl = useIntl()

    return (
        <div className={`mobile-legend ${type}`}>
            <Typography variant={'sectionHeadline'}>{intl.formatMessage({ id: `hall.legend.${type}` })}</Typography>
            <Icon name={type} />
        </div>
    )
}

export default MobileLegend
